import { db } from '../../firebase';
import { Network } from '../types/network';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, query, getDoc } from 'firebase/firestore';
import { parseContent, parseContents } from '../utils';
import { parseNetwork, parseNetworks } from './parser';
import { ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorFromRawError, isProjectError } from '../../utils/errors';
import { CreateNetworkDto, UpdateNetworkDto } from '../typeDtos/network';

export const getAllNetworks = async (): Promise<Network[]> => {
  try {
    const _query = query(collection(db, 'networks'));
    const rawResult = await getDocs(_query);
    const parsed = parseContents(rawResult);
    const networks = await parseNetworks(parsed);
    return networks;
  } catch (error) {
    console.log(`[NETWORKS] Error at getAllNetworks`, error);
    return [];
  }
};

export const getNetworkById = async (id: string) => {
  try {
    const _query = await getDoc(doc(db, 'networks', id));
    if (!_query.exists()) {
      console.log('No such document!');
      return undefined;
    }
    const result = await parseNetwork(parseContent(_query));
    const resultError = isProjectError(result);
    if (!resultError) {
      return result as Network;
    }
  } catch (error) {
    console.log(`[NETWORKS] Error at getNetworkById with id ${id}:`, error);
    return undefined;
  }
};

export const createNetwork = async (
  data: CreateNetworkDto,
): Promise<ProjectErrorType | { success: boolean; id: string }> => {
  try {
    const nowTs = new Date().getTime();
    const _data = {
      ...data,
      createdAt: nowTs,
      updatedAt: nowTs,
    };
    const result = await addDoc(collection(db, 'networks'), _data);
    return { success: true, id: result?.id };
  } catch (e) {
    console.log('[NETWORKS] Error at createNetwork:', e);
    return getProjectErrorFromRawError(e as Error);
  }
};

export const updateNetwork = async (data: UpdateNetworkDto): Promise<ProjectErrorType | { success: boolean }> => {
  try {
    const nowTs = new Date().getTime();
    const _data = { ...data, updatedAt: nowTs };
    const docRef = doc(db, 'networks', _data?.id);
    await updateDoc(docRef, _data);
    return { success: true };
  } catch (e) {
    console.log('[NETWORKS] Error at updateNetwork:', e);
    return getProjectErrorFromRawError(e as Error);
  }
};

export const deleteNetwork = async (id: string): Promise<ProjectErrorType | { success: boolean }> => {
  try {
    const docRef = doc(db, 'networks', id);
    await deleteDoc(docRef);
    return { success: true };
  } catch (e) {
    console.log('[NETWORKS] Error at deleteNetwork:', e);
    return getProjectErrorFromRawError(e as Error);
  }
};
